document.addEventListener('DOMContentLoaded', () => {
    const articleBodyItemProp = 'articleBody';
    const tableOfContentsItemProp = 'tableOfContents';
  
    const getArticleBody = () => {
      return document.querySelector(`[itemprop="${articleBodyItemProp}"]`);
    };
  
    const getHeadings = () => {
        const articleBody = getArticleBody();
        if (!articleBody) return null;
        
        const allHeadings = articleBody.querySelectorAll('h2, h3');
        if (allHeadings.length <= 1) return null;
        
        // 「はじめに」を除外した見出し
        return Array.prototype.slice.call(allHeadings, 1);
    };
      
    const existsTableOfContents = () => {
      return !!document.querySelector(`[itemprop="${tableOfContentsItemProp}"]`);
    };
  
    const generateSlug = (text) => {
      return text
        .toLowerCase()
        .trim()
        .replace(/[^\wぁ-んァ-ン一-龥ー]+/g, '-') // 日本語と英数字以外の文字をハイフンに
        .replace(/-+/g, '-')                      // 連続ハイフンを1個に
        .replace(/^-|-$/g, '');                   // 先頭・末尾のハイフンを削除
    };
  
    const generateAnchor = (id, text) => {
      const anchor = document.createElement('a');
      anchor.style.display = 'block';
      anchor.style.width = '100%';
      anchor.style.padding = 0;
      anchor.style.margin = 0;
      anchor.style.lineHeight = '21px';
      anchor.style.fontSize = '14px';
      anchor.style.color = '#6f7372';
      anchor.textContent = text;
      anchor.setAttribute('href', `#${id}`);
      return anchor;
    };
  
    const generateListItem = (id, text, isNest = false) => {
      const listItem = document.createElement('li');
      listItem.style.padding = '8px 0';
      listItem.style.margin = 0;
      listItem.style.listStyleType = 'none';
      if (isNest) {
        listItem.style.paddingLeft = '24px';
      }
      const anchor = generateAnchor(id, text);
      listItem.appendChild(anchor);
      return listItem;
    };
  
    const generateList = (headings) => {
      if (!headings) return;
  
      const list = document.createElement('ul');
      list.style.padding = 0;
      list.style.margin = '16px 0 0';
      list.style.listStyle = 'none';
      headings.forEach((heading) => {
        const slug = generateSlug(heading.textContent);
        const text = heading.textContent.trim();
        const listItem = generateListItem(slug, text, heading.tagName === 'H3');
        list.appendChild(listItem);
      });
      return list;
    };
  
    const generateTitle = () => {
      const title = document.createElement('h2');
      title.style.fontSize = '16px';
      title.style.fontWeight = '700';
      title.style.margin = 0;
      title.style.color = 'rgb(111, 115, 114)';
      title.style.lineHeight = 1.5;
      title.style.letterSpacing = '0.04em';
      const content = document.createTextNode('目次');
      title.appendChild(content);
      return title;
    };
  
    const generateTableOfContents = (headings) => {
      if (!headings) return;
  
      const tableOfContents = document.createElement('nav');
      tableOfContents.setAttribute('itemprop', tableOfContentsItemProp);
      tableOfContents.style.padding = '16px';
      tableOfContents.style.margin = '4rem 0';
      tableOfContents.style.backgroundColor = '#f7f9f9';
      const title = generateTitle();
      tableOfContents.appendChild(title);
      const list = generateList(headings);
      tableOfContents.appendChild(list);
      return tableOfContents;
    };
  
    const addIdToHeading = () => {
        const articleBody = getArticleBody();
        const allHeadings = articleBody?.querySelectorAll('h2, h3');
        if (!articleBody || !allHeadings) return;
      
        allHeadings.forEach((heading) => {
          const slug = generateSlug(heading.textContent);
          heading.id = slug;
        });
    };
  
    const addTableOfContents = () => {
        const articleBody = getArticleBody();
        const allHeadings = articleBody?.querySelectorAll('h2, h3');
        if (!articleBody || !allHeadings || allHeadings.length <= 1) return;
      
        // 「はじめに」以降の見出しを抽出
        const headings = Array.prototype.slice.call(allHeadings, 1);
        const secondHeading = headings[0];
      
        const tableOfContents = generateTableOfContents(headings);
        if (!tableOfContents || !secondHeading) return;
        if (existsTableOfContents()) return;
      
        // 親要素を取得し、その中でsecondHeadingの直前に挿入
        const parent = secondHeading.parentElement;
        if (parent && parent.contains(secondHeading)) {
          parent.insertBefore(tableOfContents, secondHeading);
        } else {
          // 保険として冒頭に入れる
          articleBody.insertBefore(tableOfContents, articleBody.firstChild);
        }
    };            
      
    // スムーズスクロール処理
    const enableSmoothScroll = () => {
      const tocLinks = document.querySelectorAll('nav[itemprop="tableOfContents"] a');
      tocLinks.forEach(link => {
        link.addEventListener('click', function(e) {
          e.preventDefault();
          const targetId = decodeURIComponent(this.getAttribute('href').substring(1));
          const target = document.getElementById(targetId);
          if (target) {
            const offset = 80; // 固定ヘッダー等があれば調整0
            const top = target.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({
              top,
              behavior: 'smooth'
            });
          }
        });
      });
    };
  
    // 実行
    addIdToHeading();
    addTableOfContents();
    enableSmoothScroll();
});
  